// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import {
    chain,
    DispatchBeginLoadWishListLines,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

type HandlerType = Parameters<typeof DispatchBeginLoadWishListLines>[0];

export const WaitForWishListRequest = async (props: HandlerType) => {
    const wishListLoadCompletes = () => {
        return !getWishListState(props.getState(), props.dataViewParameter.wishListId).isLoading;
    };

    await waitFor(wishListLoadCompletes);
};

addToChainAfter(chain, DispatchBeginLoadWishListLines, WaitForWishListRequest);
